import URL from '@/finsight/Router/urlConstants';
import { Link } from '@/Framework/Router/Next/Link';
import TruncateTextWithTooltip from '@dealroadshow/uikit/core/components/Tooltip/TruncateTextWithTooltip';

const HeadlineCell = ({ row, cellData }) => {
  const urlToArticle = `${ URL.CREDIT_FLOW_ARTICLE }-${ row.viewId }`;

  return (
    <TruncateTextWithTooltip value={ cellData }>
      <Link to={ urlToArticle } target="_blank">
        { cellData }
      </Link>
    </TruncateTextWithTooltip>
  );
};

export default HeadlineCell;
